import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-document-color",
  "use": "rt-base-document-color-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-document-color\"><path d=\"M112.889 170.667h398.847c23.23 0 44.047 14.34 52.324 36.045l246.607 646.621H112.889c-30.928 0-56-25.072-56-56V226.667c0-30.928 25.072-56 56-56z\" fill=\"#53A4FC\" fill-opacity=\".3\" /><path d=\"M112 170h399.588c22.832 0 43.377 13.86 51.926 35.031L595 283H56v-57c0-30.928 25.072-56 56-56z\" fill=\"#53A4FC\" /><path d=\"M56 283h854c30.928 0 56 25.072 56 56v457c0 30.928-25.072 56-56 56H112c-30.928 0-56-25.072-56-56V283z\" fill=\"#1890FF\" fill-opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/document-color.svg
// module id = 1729
// module chunks = 137